export const AdminRoutes = Object.freeze({
    ADMIN_ROUTE: '/Admin',
    AWARDING_RULES_ROUTE: '/Admin/AwardingRules',
    GLOBAL_SETUP_ROUTE: '/Admin/GlobalSetup',
});

export const tabsOptions = Object.freeze({
    BidSetups: 0,
    AwardingRules: 1,
    GlobalSetup: 2,
});

export const AdminRoutesDictionary = Object.freeze({
    [tabsOptions.BidSetups]: AdminRoutes.ADMIN_ROUTE,
    [tabsOptions.AwardingRules]: AdminRoutes.AWARDING_RULES_ROUTE,
    [tabsOptions.GlobalSetup]: AdminRoutes.GLOBAL_SETUP_ROUTE,
});

/**
 * @param {import("react-router").NavigateFunction} navigateFunction
 * @returns {(id: number) => void}
 */
export const handlePageOptionSelected = (navigateFunction) => (id) => {
    switch (id) {
        case tabsOptions.BidSetups:
            navigateFunction(AdminRoutes.ADMIN_ROUTE);
            break;
        case tabsOptions.AwardingRules:
            navigateFunction(AdminRoutes.AWARDING_RULES_ROUTE);
            break;
        case tabsOptions.GlobalSetup:
            navigateFunction(AdminRoutes.GLOBAL_SETUP_ROUTE);
            break;
        default:
            navigateFunction(AdminRoutes.ADMIN_ROUTE);
            break;
    }
};
